import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FillLabel } from './FillLabel';

/** Floating cookie notice — navy card, bottom-left, on the page's content margin. */
export function CookieBanner() {
  const [visible, setVisible] = useState(true);
  return <AnimatePresence data-id="element-73" data-mp="1d1ordbtedd5f">
      {visible && <motion.div role="dialog" aria-label="Cookie consent" initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-5 left-5 right-5 z-50 border border-cream/15 bg-navy p-6 text-cream shadow-[0_12px_40px_rgba(10,16,30,0.35)] sm:right-auto sm:max-w-[380px] md:bottom-8 md:left-16 lg:left-24" data-id="element-74" data-mp="1d0njfg7oh6rx">
          <p className="flex items-center gap-3 font-accent text-[11px] uppercase tracking-[0.08em] text-cream/80" data-id="element-75" data-mp="pb1ioobnqjht">
            <span aria-hidden="true" className="h-[6px] w-[6px] bg-white" data-id="element-76" data-mp="kekuju4gk54q" />
            Cookies
          </p>
          <p className="mt-3 text-[14px] leading-[1.55] text-cream/80" data-id="element-77" data-mp="xtpyqzeoqxwv">
            We use cookies to improve your experience and understand how the site is used.{' '}
            <a href="/cookies" className="link-soft no-arrow text-cream underline decoration-cream/40 underline-offset-[3px]" data-id="element-78" data-mp="owfnhe1vb8ry">
              Privacy Policy
            </a>
          </p>
          <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-79" data-mp="1hkl9s58kl5tw">
            <button type="button" onClick={() => setVisible(false)} className="btn-fill btn-fill-light h-10 whitespace-nowrap border border-cream/25 font-accent text-[11px] uppercase tracking-[0.08em] text-cream/85" data-id="element-80" data-mp="1ll53szxujtbt">
              <FillLabel data-id="element-81" data-mp="1cim76xknmcy0">Decline</FillLabel>
            </button>
            <button type="button" onClick={() => setVisible(false)} className="btn-fill btn-fill-light h-10 whitespace-nowrap border border-cream/60 font-accent text-[11px] uppercase tracking-[0.08em] text-cream" data-id="element-82" data-mp="3sajqm6li7uhr">
              <FillLabel data-id="element-83" data-mp="39787oa0a1jev">Accept</FillLabel>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}